import React, { useEffect } from "react";

// import sections
import HeroSection from "./sections/HeroSection";
import ContactUsSection from "../home/sections/ContactUsSection";

const Contact = ({ title }) => {
  useEffect(() => {
    const original = document.title;
    document.title = title + " | " + original;
    return () => {
      document.title = original;
    };
  }, [title]);

  return (
    <div>
      <HeroSection />
      <ContactUsSection />
    </div>
  );
};

export default Contact;
